import { LayerBottom, Scroller, Layer, Switch } from 'components';
import useApp from 'hooks/useApp'
import SlideBanner from 'components/SlideBanner';
import SquareBox from 'components/SquareBox';
import React, { useCallback, useEffect, useState } from 'react';
import Lib from 'library';
import { Link, useNavigate } from 'react-router-dom';
import Tabs from 'views/main/home/Tabs';
import LevelTabPane from 'views/main/home/LevelTabPane';
import TopTabPane from './TopTabPane';
import { BellIcon, SettingIcon } from 'components/HeaderComponents';
import { atom, useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { userState } from 'states';
import styles from '../../home/index.module.css';
import Native from 'library/native';
import EventDetailLayer from 'views/setting/EventDetailLayer';
import EventLayer from 'views/setting/EventLayer';
import { pushDataState, showEventDetailLayerState, showEventLayerState, showFaqLayerState, showNoticeLayerState } from 'views/setting/states';
import { mydataRefreshState } from "views/home/states";
import BenefitCardDetailLayer from 'views/recommend/home/BenefitCardDetailLayer';
import FinanceCardDetailLayer from 'views/recommend/home/FinanceCardDetailLayer';
import FinanceSavingDetailLayer_1 from 'views/recommend/home/FinanceSavingDetailLayer_1';
import FinanceSavingDetailLayer_2 from 'views/recommend/home/FinanceSavingDetailLayer_2';
import FinanceSavingDetailLayer_3 from 'views/recommend/home/FinanceSavingDetailLayer_3';
import FinanceLoanDetailLayer_1 from 'views/recommend/home/FinanceLoanDetailLayer_1';
import FinanceLoanDetailLayer_2 from 'views/recommend/home/FinanceLoanDetailLayer_2';
import FinanceLoanDetailLayer_3 from 'views/recommend/home/FinanceLoanDetailLayer_3';
import Faq from 'views/setting/Faq';
import Notice from 'views/setting/Notice';
import styles2 from '../../../css/limb.css'

const textPopMainState = atom({
	key: "textPopMainState",
	default: false
})

const imgPopMainState = atom({
	key: "imgPopMainState",
	default: false
})

const openPopMainState = atom({
	key: "openPopMainState",
	default: (url, title, id, callback) => {
		if (!url) return
		if (!url.match(/:\/\//)) url = `http://${url}`
		console.log({ url })
		Native.execute("Popup", "openPopup", callback, {
			view_id: id,
			url: url,
			title: title
		})
	}
})

const Main = () => {
    const App = useApp();
    const navigate = useNavigate();
    const [myMoney, setMyMoney] = useState();
    const [myExpense, setMyExpense] = useState();
    const [tooltip, setTooltip] = useState({"MyMoney": false, "MyExpense": false});
	const [amtShowYn, setAmtShowYn] = useState(window.localStorage.getItem("showAmountView") === "false" ? "N" : "Y");	// [로컬스토리지의 변수값 Read. 20221021]
    // const [amtShowYn, setAmtShowYn] = useState(window.localStorage.getItem("showAmountView"));	// [로컬스토리지의 변수값 Read. 20221021]
	const [levelTabs, setLevelTabs] = useState([]);

    // 기존 기능
    const [showImagePop, setShowImagePop] = useState(false)  // 하단 popup
    const [showTextPopup, setShowTextPopup] = useState(false)  // 긴급공지 popup
    const moneeyUser = useRecoilValue(userState)   // 모니 유저 정보

    // 이미지 팝업 정보
	const [imgPop, setImgPop] = useState()
	const [imgPopChk, setImgPopChk] = useRecoilState(imgPopMainState)

	// 긴급공지 팝업 정보
	const [textPop, setTextPop] = useState()
	const textPopChk = useRecoilValue(textPopMainState)
	const resetTextPopChk = useResetRecoilState(textPopMainState)

	// 이벤트 리스트
	const [eventList, setEventList] = useState()

	// PUSH 레이어
	const pushData = useRecoilValue(pushDataState);
	const setShowNoticeLayer = useSetRecoilState(showNoticeLayerState)	// 공지사항
	const setShowEventLayer = useSetRecoilState(showEventLayerState) //이벤트
	const setShowFaqLayer = useSetRecoilState(showFaqLayerState) //FAQ

	const [mydataRefresh, setMydataRefresh] = useRecoilState(mydataRefreshState);	// 마이데이터 업데이트 중 여부

	const [bankAmtInfo, setBankAmtInfo] = useState(null); // 은행 금액정보

	const [bankPage,setBankPage] = useState(''); // 은행 link 정보

	// 은행 금액 조회
	const getBankData = () => {
		
		Lib.get(`/api/mydata/main/bank`,
			data => {
				
				setBankAmtInfo(data);
				if(data.mydataMainBankAcntAmtResVo && data.mydataMainBankAcntAmtResVo.totalBlncAmt){
					// backaccount
					setBankPage("/mydata/bankAccount");
				}else if(data.mydataMainBankBlncAmtResVo && data.mydataMainBankBlncAmtResVo.totalLoanBlncAmt){
					// bank loan
					setBankPage("/mydata/bankLoan");
				}else if(data.mydataMainBankEvalAmtResVo && data.mydataMainBankEvalAmtResVo.totalEvalAmt){
					setBankPage("/mydata/bankInvest");
				}
			}
		)
	}

    const getMyMoney = () => {
        console.log("TODO 내가 모은 돈 가져오기");

		Lib.get(`/api/my/main/asset`, (data) => {
			console.log(data);
			setMyMoney(data);
		});

        // // 데이터가 있는 경우
        // setMyMoney({
        //     totalEvalAmt: 8320000,                // 총 금액
        //     evalAmtDiff: -150300,                 // 이전 총 금액의 차 (-)
        //     // evalAmtDiff: 245900,               // 이전 총 금액의 차 (+)
        //     // evalAmtDiff: 0,                    // 이전 총 금액의 차 (변동없음)
        //     lastLinkUpDt: "2022-11-04 13:21:11",
        //     detail: {                              // 업권별 데이터
        //         "bank" : {                        // 업권 KEY
        //             evalAmt: 88888,
        //             evalAmtRate: 50,
		// 			linkupFlag: true,				  // 연동여부
        //         },
        //         "irp" : {
        //             evalAmt: 0,
        //             evalAmtRate: 0,
		// 			linkupFlag: false
        //         },
        //         "invest" : {
        //             evalAmt: 0,
        //             evalAmtRate: 50,
		// 			linkupFlag: true
        //         }
        //     },
        // });

        // 데이터가 없는 경우
        // setMyMoney();
    }
	
	const onClickMydataUpdate = () => {
		// 마이데이터 연동 업데이트
		setMydataRefresh("Y");
		Lib.get(`api/data/lnkup/refresh`, 
			() => {
				setMydataRefresh("N");
				// 연동 완료시 데이터 다시 가져옴
				getMyMoney();
				getMyExpense();
				getLevelTabs();
			}
		);
	}

    const getMyExpense = () => {
		//  내가 쓴 돈 API 조회
		Lib.get(`api/my/main/cnsmp`, 
			data => {
				console.log("내가 쓴 돈",data);
				setMyExpense(data);
			}
		);
        
        // // 데이터가 있는 경우
        // setMyExpense({
        //     month: "01",                        // 해당 데이터의 월
        //     payExpAmt: "0",                       // 지출금액
        //     prevPayExpAmt: "0",                    // 지난달 지출금액 (구하기 쉬운경우.. -, +, 변동없음으로 받아도됨)
		// 	linkUpFlag: true
        // });
    }

	const getLevelTabs = useCallback((type) => {
		Lib.get(`/api/comm/cd/MAIN_LEVEL_TP`, data => setLevelTabs(data)); // 공통 코드 불러오기
	}, []);

    // 씽크풀 연동 
	const thinkPoolClick = () => {
		Lib.get(`/api/comm/terms/agree/chk/ctgry/STOCK`,
			data => {
				if(data.termsCtgryAgreeYn==="Y") {
					navigate("/thinkpool/thinkInfo")
				} else {
					navigate("/thinkpool/thinkIntro")
				}
			}
		)
	}

    // 기존기능) 쿠키 생성
	const setCookie = (name, value) => {
		const today = new Date().getTime()
		const expires = new Date(today + ((1000 * 60 * 60 * 24) * 1)).toUTCString()
		console.log({ expires })
		// let tomorrow = new Date(parseInt(new Date().getTime() / 86400000) * 86400000 + 54000000);
		// console.log({ tomorrow })
		let myCookie = ''
		myCookie += name + '=' + value + ';'
		myCookie += 'expires=' + expires
		document.cookie = myCookie;  // 쿠키 설정,생성
	}

    // 기존기능) 이미지 Layer
	const closeImagePopLayer = () => {
		// 하루동안 안보기 클릭시 cookie 저장
		// 마지막 인자값 숫자는 날자를 지정  0: 오늘하루동안 안보기  3: 3일동안 안보기 7: 일주일동안 안보기
		if (imgPopChk) {
			setCookie('ipc_' + moneeyUser.mbId, 'pop')
		}
		setShowImagePop(false)
	}

	// 쿠키 확인
	const getCookie = name => {
		if (moneeyUser === undefined) { return false }
		let cookies = document.cookie.split(';')
		if (cookies[0] === '') return true
		let checkCookie = cookies.find(item => {
			if (item.indexOf(name + moneeyUser.mbId) > -1) {
				return true
			} else {
				return false
			}
		})
		return checkCookie ? false : true;
	}

	const getPops = () => {
		if (!moneeyUser) return
		Lib.get(`/api/main/chk/popup`, data => {
			//console.log("홈팝업목록[이벤트/팝업] data", JSON.stringify(data));
			setImgPop(data.lstImg);
			setShowImagePop(getCookie('ipc_'));
			setTextPop(data.lstTxt);
			setShowTextPopup(getCookie('tpc_'));
		})
	}

	// 긴급공지 Layer
	const closeTextPopLayer = () => {
		// 하루동안 안보기 클릭시 cookie 저장
		// 마지막 인자값 숫자는 날자를 지정  0: 오늘하루동안 안보기  3: 3일동안 안보기 7: 일주일동안 안보기
		if (textPopChk) {
			setCookie('tpc_' + moneeyUser.mbId, 'pop', 0)
		}
		setShowTextPopup(false)
	}

	useEffect(() => {
		// PUSH Layer 처리
		if (pushData && pushData.url) {
			console.log("푸쉬 데이터가 바뀌는 경우 !!!");
			const urlArr = (pushData.url).split("/");
			if (urlArr[1] === "layer") {
				// layers.map(fn => {
				// 	fn();
				// 	console.log("레이어 닫음12323");
				// });
				// setLayers([]);

				switch(urlArr[2]) {
					case "notice":
						console.log(urlArr[2]);
						setShowNoticeLayer(true);
						break;
					case "faq":
						console.log(urlArr[2]);
						setShowFaqLayer(true);
						break;
					case "event":
						console.log(urlArr[2]);
						// getEventData();
						setShowEventLayer(true);
						break;
					default :
						console.log(urlArr[2]);
						break;
				}
			}
		}
	}, [pushData]);

	useEffect(() => {
		if (mydataRefresh === "N") {
			getMyMoney();
			getMyExpense();
			getLevelTabs();
		}
	}, [mydataRefresh]);

    useEffect(() => {
        App.setHeader({
			show: true,
			title: <></>,
			left: <Link to="/"><i className="icon-header-logo"></i><span className="btn-icon">moneey</span></Link>,
			right: <><BellIcon /><SettingIcon /></>,
			// type: "transparent"
		});

        App.setShowNav(true);
		App.setMainClass("changeWhite");

		// 이벤트 팝업 가져오기
		getPops();
		
        getMyMoney();
        getMyExpense();
		getLevelTabs();

		getBankData();

		return () => {
			setImgPopChk()
			resetTextPopChk()
			window.onBackPress = App.onBackPress
		}
    }, []);

    return (
        <div className="page">
            <div id="content">
                <SlideBanner/>

                <SquareBox>
                    <div className="top">
                        <p className="cmm-tit">내가 모은 돈</p>
                        <div className="cmm-tooltip">
                            <button type="button" aria-expanded={tooltip.MyMoney} onClick={()=> setTooltip({...tooltip, "MyMoney": !tooltip.MyMoney})}><span>설명</span></button>
                            <div className="view">
                                <button className="btn-delete" onClick={()=> setTooltip({...tooltip, "MyMoney": !tooltip.MyMoney})}><span>설명 닫기</span></button>
                                <p>내가 모든 돈은 은행, 증권, 개인IRP 각 계좌의 자산 총합을 모두 더한 금액입니다.</p>
                            </div>
                        </div>
                        {/* <button type="button" className="btn-base-blue" onClick={() => {navigate("/data", 
                        { state: {
                            preIndstCd: "",
                            from: "/home"
                        }})}}><span>데이터 연결</span></button> */}
                    </div>
                    {
                        !myMoney
                            ? null
                            : myMoney.lastLinkUpDt === ""
								? <div className="data-none">
									<p>연결된 자산이 없어요.<br/>{moneeyUser && moneeyUser.mbNm}님의 자산을 추가해주세요.</p>
									<button onClick={() => {navigate("/data", 
										{ state: {
											preIndstCd: "",
											from: "/home"
										}})}} className="btn-base-blue"><span>자산연결</span></button>
								</div>
								:<>
									<div className="main">
										<div className="cmm-form main-switch">
											<div className="flex-align_center justify_between">
												<span className="label">금액보기</span>
												<Switch offText={amtShowYn === 'Y' ? 'ON' : 'OFF'} on={amtShowYn === 'Y' ? true : false}
													onToggle={() => {
														if (amtShowYn === "Y") {
															setAmtShowYn("N");
															window.localStorage.setItem("showAmountView", false); // [로컬스토리지 관련항목 동기화. 20221021]
														} else {
															setAmtShowYn("Y");
															window.localStorage.setItem("showAmountView", true);  // [로컬스토리지 관련항목 동기화. 20221021]
														}
													}}
												>{amtShowYn === 'Y' ? 'ON' : 'OFF'}</Switch>
											</div>
										</div>
										<div className="cmm-tit">
											<p><b>{ amtShowYn === 'Y' ? Lib.addComma(myMoney.totalEvalAmt): "금액숨김" }</b>{amtShowYn === 'Y' && "원"}</p>
											{
												myMoney.evalAmtDiff != 0 &&
													(myMoney.evalAmtDiff > 0 
													? <span className="cmm-tag rise"><em>{Lib.addComma((myMoney.evalAmtDiff))}</em>원</span>
													: <span className="cmm-tag decrease"><em>{Lib.addComma((myMoney.evalAmtDiff))}</em>원</span>)
											}
										</div>
										<div className="figure-bar">
											<div className="bar">
												{ (myMoney.detail.bank.linkupFlag && myMoney.detail.bank.evalAmtRate != 0) && <p className="bank" style={{width: myMoney.detail.bank.evalAmtRate + "%"}}><span>은행</span></p>}
												{ (myMoney.detail.irp.linkupFlag && myMoney.detail.irp.evalAmtRate != 0) && <p className="irp" style={{width: myMoney.detail.irp.evalAmtRate + "%"}}><span>개인형IRP</span></p>}
												{ (myMoney.detail.invest.linkupFlag && myMoney.detail.invest.evalAmtRate != 0) && <p className="stock" style={{width: myMoney.detail.invest.evalAmtRate + "%"}}><span>증권</span></p>}
											</div>
											<p className="date">
												{
													mydataRefresh === "N"
														? <>
															업데이트 <span>{myMoney.lastLinkUpDt}</span>
															<button type="button" className="btn-refresh" onClick={onClickMydataUpdate}><span className="btn-icon">새로고침</span></button>
														</>
														: <>업데이트 중 ...</>
												}
												
											</p>
										</div>
									</div>
									<div className="bottom">
										<ul className="cmm-list">
											{ 
												myMoney.detail.bank.linkupFlag &&
												<li>
													<Link to={bankPage}>
														<span className="cmm-tag bank"><em>은행</em></span>
														<span className="num">
															<strong>{ amtShowYn === 'Y' ? Lib.addComma(myMoney.detail.bank.evalAmt) + "원" : "금액숨김" }</strong>
															<em>{ myMoney.detail.bank.evalAmtRate }%</em>
														</span>
														<i className="icon-next-s" ></i>
													</Link>
												</li>
											}
											{
												myMoney.detail.irp.linkupFlag &&
												<li>
													<Link to="/mydata/irpBank">
														<span className="cmm-tag irp"><em>개인형IRP</em></span>
														<span className="num">
															<strong>{ amtShowYn === 'Y' ? Lib.addComma(myMoney.detail.irp.evalAmt) + "원" : "금액숨김" }</strong>
															<em>{ myMoney.detail.irp.evalAmtRate }%</em>
														</span>
														<i className="icon-next-s"></i>
													</Link>
												</li>
											}
											{
												myMoney.detail.invest.linkupFlag &&
												<li>
													<Link to="/mydata/stock">
														<span className="cmm-tag stock"><em>증권</em></span>
														<span className="num">
															<strong>{ amtShowYn === 'Y' ? Lib.addComma(myMoney.detail.invest.evalAmt) + "원" : "금액숨김" }</strong>
															<em>{ myMoney.detail.invest.evalAmtRate }%</em>
														</span>
														<i className="icon-next-s"></i>
													</Link>
												</li>
											}
										</ul>
									</div>
								</>
                    }
                </SquareBox>

                <SquareBox>
                    <div className="top">
                        <p className="cmm-tit">내가 쓴 돈</p>
                        <div className="cmm-tooltip">
                            <button type="button" aria-expanded={tooltip.MyExpense} onClick={()=> setTooltip({...tooltip, "MyExpense": !tooltip.MyExpense})}><span>설명</span></button>
                            <div className="view">
                                <button className="btn-delete" onClick={()=> setTooltip({...tooltip, "MyExpense": !tooltip.MyExpense})}><span>설명 닫기</span></button>
                                <p>연동된 카드에서 당월(1일~말일) 사용한 돈의 합계를 말합니다.</p>
                            </div>
                        </div>
						<button className="icon-next-m" onClick={() => {{myExpense && !myExpense.linkUpFlag ? navigate("/data", {state: {from:"/home"}}) : navigate("/mydata/card")}}}><span className="btn-icon">더보기</span></button>
                    </div>
                    <div className="info">
                        {/* <p className="desc">{ Lib.getToMonth() }월 카드 이용내역</p> */}
                        {
                            myExpense &&
								!myExpense.linkUpFlag
									? <div className="data-none">
										<p>연결된 자산이 없어요.<br/>{moneeyUser && moneeyUser.mbNm}님의 카드를 추가해주세요.</p>
									</div>
									:
										myExpense &&
										<>
											{
												parseInt(myExpense.prevPayExpAmt) < parseInt(myExpense.payExpAmt) &&
												<div className="cmm-tit increase">
													<span className="cmm-tag">지난달 대비 증가 했어요</span>
													<span className="num"><em>{ Lib.addComma(myExpense.payExpAmt) }</em>원</span>
												</div>
											}
											{
												parseInt(myExpense.prevPayExpAmt) > parseInt(myExpense.payExpAmt) &&
												<div className="cmm-tit decrease">
													<span className="cmm-tag">지난달 대비 감소 했어요</span>
													<span className="num"><em>{ Lib.addComma(myExpense.payExpAmt) }</em>원</span>
												</div>
											}
											{
												parseInt(myExpense.prevPayExpAmt) === parseInt(myExpense.payExpAmt) &&
												<div className="cmm-tit">
													<span className="num"><em>{ Lib.addComma(myExpense.payExpAmt) }</em>원</span>
												</div>
											}
										</>
                            }
                    </div>
                </SquareBox>

                <div className="benner-ai" onClick={thinkPoolClick}>
                    <em>AI가 알려주는 내 종목 분석!</em>
                    <span>My Stock Manager로<br/>성공투자 하세요!</span>
                </div>

                <p className="cmm-tit">잔고가 커지는만큼 레벨도 UP!</p>

				{
					levelTabs.length > 0 &&
						<Tabs>
							{
								levelTabs.map((item, index) => (
									<LevelTabPane key={index} title={item.commNm} type={item.commCd} />
								))
							}
						</Tabs>
				}
               

                <p className="cmm-tit">모니가 추천해주는 금융상품</p>
                <p className="cmm-txt">가장 많이 사랑받는 TOP 3</p>

                <Tabs>
                    <TopTabPane title="카드" type="CARD_BNFT" />
                    <TopTabPane title="저축" type="SAVING" />
                    <TopTabPane title="대출" type="LOAN"/>
                </Tabs>

                <BannerBottom show={showImagePop} closeLayer={closeImagePopLayer} closeButton={false} imgPop={imgPop} />
				<TextPopup show={showTextPopup} closeLayer={closeTextPopLayer} textPop={textPop} />
				<Faq />
				<Notice />
				{/* <EventLayer eventss={eventList} /> */}

				<BenefitCardDetailLayer />
                <FinanceCardDetailLayer />

                {/* TOP3 - 저축 Detail Layer */}
                <FinanceSavingDetailLayer_1 />
                <FinanceSavingDetailLayer_2 />
                <FinanceSavingDetailLayer_3 />
                
                {/* TOP3 - 대출 Detail Layer */}
                <FinanceLoanDetailLayer_1 />
                <FinanceLoanDetailLayer_2 />
                <FinanceLoanDetailLayer_3 />
            </div>
        </div>
    )
}

// layer popup

// 팝업 등록 시 '하단'
const BannerBottom = ({ show, closeLayer, closeButton, imgPop }) => {

	const [checked, setChecked] = useRecoilState(imgPopMainState)
	// const openPop = useRecoilValue(openPopMainState)

	// 이벤트 팝업 정보
	const [eventList, setEventList] = useState()
	const [eventDetail, setEventDetail] = useState()
	const [showEventLayer, setShowEventLayer] = useRecoilState(showEventLayerState)
	const setShowEventDetailLayerState = useSetRecoilState(showEventDetailLayerState)

	// 공지 팝업 정보
	const [detailId, setDetailId] = useState()
	const [showDetail, setShowDetail] = useState(false)
	
	// 이벤트 리스트 데이터 가져오기
	const getData = () => {
		Lib.get(`/api/more/cstmr/srvc/event`, data => {
			//console.log('data : ' + JSON.stringify(data))
			setEventList(data)
			setShowEventLayer(true);
		})
	}

	// 이벤트 배너 디테일 화면
	const getDataEventDetail = (id) => {
		Lib.get(`/api/more/cstmr/srvc/event/${id}`, data => {
			setEventDetail(data)
			setShowEventDetailLayerState(true)
		})
	}

	// 공지사항 배너 디테일 화면
	const getDataNotiDetail = (id) => {
		//console.log('id : ', id);
		setDetailId(id)
		setShowDetail(true)
	}

	const openWebview = url => {
		Native.execute("AppManager", "openScheme", () => { }, {
			url: url
		})
	}

	if (imgPop && imgPop.length === 0) { return false }
	return (
		<>
			<LayerBottom show={show} closeLayer={closeLayer} closeButton={closeButton}>
				{imgPop && imgPop.length === 1 ?
					<div className="slider">
						<ul>
							<li>
								<div className="img-box popup-banner" onClick={() => {
									//openPop(imgPop[0].linkUrl, imgPop[0].operTitle, "imgPop_0")
									closeLayer();
									if (imgPop[0].linkTpCd === "EVENT") {
										//getData();							// 1.이벤트목록
										getDataEventDetail(imgPop[0].linkUrl);	// 2.이벤트상세
									} else if (imgPop[0].linkTpCd === "NOTI") {
										getDataNotiDetail(imgPop[0].linkUrl);	// 1.공지상세
									} else {
										openWebview(imgPop[0].linkUrl);
									}
								}}>
									<img src={`/api/comm/showImage/${imgPop[0].sstmFileId}`} alt="" />
								</div>
							</li>
						</ul>
					</div>
					:
					<div className="slider">
						<Scroller dotsStyle={styles.dotsStyle} dotStyle={styles.dotStyle} activeDotStyle={styles.activeDotStyle} style={{ borderRadius: "3rem" }}>
							{imgPop && imgPop.map((item, index) => {
								return (
									<li key={index} style={{ marginRight: "2rem" }}>
										<div className="img-box popup-banner" onClick={() => {
											//openPop(item.linkUrl, item.operTitle, `imgPop_${index}`)
											//closeLayer();
											if (item.linkTpCd === "EVENT") {
												//getData();						// 1.이벤트목록
												getDataEventDetail(item.linkUrl);	// 2.이벤트상세
											} else if (item.linkTpCd === "NOTI") {
												getDataNotiDetail(item.linkUrl);	// 1.공지상세
											} else {
												openWebview(item.linkUrl);
											}
										}}>
											<img src={`/api/comm/showImage/${item.sstmFileId}`} alt="" />
										</div>
									</li>
								)
							})}
						</Scroller>
					</div>
				}
				<div className="flex-justify_between align_center mt_30">
					<div className="chk" onClick={e => {
						setChecked(prev => !prev)
					}}>
						<span className={`checkMark${checked ? " on" : ""}`} />
						<label>
							<span>하루동안 보지 않기</span>
						</label>
					</div>
					<span onClick={() => closeLayer()}>닫기</span>
				</div>
			</LayerBottom>

			{/*	이벤트 팝업 레이어 추가 */}
			<EventLayer eventss={eventList} />	
			<EventDetailLayer eventDetail={eventDetail} />

			{/* 공지사항*/}		
			<NoticeDetail show={showDetail} closeLayer={setShowDetail} id={detailId} />
		</>
	)
}

//공지사항 상세 화면
const NoticeDetail = (props) => {

	const [data, setData] = useState()

	const getDetail = () => {
		Lib.get(`/api/more/cstmr/srvc/ntc/${props.id}`, data => {
			console.log('data ' + JSON.stringify(data));
			setData(data)
		})
	}

	useEffect(() => {
		props.show && getDetail()
		return () => setData()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.show])

	// 다운로드
    const downloadFile = async (fileId, fileNm) => {
		let ext = "";
		let mimeType = "";

        if (fileNm && (fileNm.split(".")).length > 0) {
            ext = (fileNm.split("."))[1];
			mimeType = `application/${ext.toLowerCase()}`
        }

		if(Native.getUserAgent() === "android") {
			Native.execute('AppManager', 'downloadFile', undefined, { url: window.location.protocol + "//" + window.location.host+'/api/comm/download/' + fileId, filename:fileNm, mimeType:mimeType});
		} else if(Native.getUserAgent() === "ios") {
			Native.execute('AppManager', 'sharePlus', undefined, { type:'url', data:window.location.protocol + "//" + window.location.host +'/api/comm/download/' + fileId, filename:fileNm});
		}
    }

	return (
		<Layer {...props} >
			{data ?
				<div className="page padding">
					<div className={styles["detail-title"]}>
						<p>{data.notiTitle}</p>
						<span>{data.notiStDe}</span>
					</div>
					<hr className="my_30" />
					<div className={styles["detail-content"]}>
						<p className="section-cont" dangerouslySetInnerHTML={{ __html: data.notiConts }}></p>
						{/*	[공지상세에서 첨부이미지 삭제. 20230128]
						{
							data.atchFileList &&
							data.atchFileList.length && data.atchFileList.map((img, index) => {
								return (
									<div key={index} className="img-box mt_20">
										<img src={`/api/comm/showImage/${img.sstmFileId}`} className="bbs_img" alt={img.orignFileNm} />
									</div>
								)
							})
						}
						*/}
						<div className="img-box mt_20">
							{data.atchFileList && 
								data.atchFileList.map((img, index) => {
									return (
										<button type="button" key={index} className="btn" onClick={() => downloadFile(img.sstmFileId, img.orignFileNm)}>
											{`${img.orignFileNm} 파일 다운로드`}
										</button>
									)
								})
							}
						</div>	
					</div>
				</div>
				:
				<div className="page padding">
					<div className="skeleton" style={{ width: "20rem", height: "2rem" }}></div>
					<div className="skeleton mt_10" style={{ width: "10rem", height: "2rem" }}></div>
					<hr className="my_20" />
					<p className="skeleton" style={{ height: "15rem" }} />
					<p className="skeleton mt_20" style={{ height: "8rem" }} />
					<p className="skeleton mt_20" style={{ height: "8rem" }} />
				</div>
			}
		</Layer>
	)
}

const TextPopup = ({ show, closeLayer, textPop }) => {

	const [checked, setChecked] = useRecoilState(textPopMainState)
	const openPop = useRecoilValue(openPopMainState)

	if (textPop && textPop.length === 0) { return false }
	return (
		<LayerBottom show={show} closeLayer={closeLayer}>
			{textPop && textPop.length === 1 ?
				<div className="slider">
					<ul>
						<li onClick={() => {
							openPop(textPop[0].linkUrl, textPop[0].operTitle, "textPop_0")
						}}>
							<div className="popup-text">
								<p className="title">ㅤ </p>
								<div className="mt_15" style={{ minHeight: "10rem" }}>
									<p className="section-cont" dangerouslySetInnerHTML={{ __html: textPop[0].operConts }}></p>
								</div>
							</div>
						</li>
					</ul>
				</div>
				:
				<div className="slider">
					<ul>
						<li>
							<div className="popup-text">
								<p className="title">ㅤ </p>
								<Scroller dotsStyle={styles.dotsStyle} dotStyle={styles.dotStyle} activeDotStyle={styles.activeDotStyle}>
									{textPop && textPop.map((item, index) => {
										return (
											<li key={index} className="mt_15" style={{ minHeight: "10rem", width: "100%" }} onClick={() => {
												openPop(item.linkUrl, item.operTitle, `textPop_${index}`)
											}}>
												<p className="section-cont" dangerouslySetInnerHTML={{ __html: item.operConts }}></p>
											</li>
										)
									})}
								</Scroller>
							</div>
						</li>
					</ul>
				</div>
			}
			<div className="flex-justify_between align_center mt_30">
				<div className="chk" onClick={e => {
					setChecked(prev => !prev)
				}}>
					<span className={`checkMark${checked ? " on" : ""}`} />
					<label>
						<span>하루동안 보지 않기</span>
					</label>
				</div>
				<span onClick={closeLayer}>닫기</span>
			</div>
		</LayerBottom>
	)
}

export default Main;